const LocationGroupType = Object.freeze({
  WARDS: "WARDS",
  WARDS__OTHERS: "WARDS__OTHERS",
  WARDS__LANGUAGES: "WARDS__LANGUAGES",
  WARDS__STUDENTS: "WARDS__STUDENTS",
  WARDS__YSA: "WARDS__YSA",
  STAKES: "STAKES",
  STAKES__OTHERS: "STAKES__OTHERS",
  STAKES__LANGUAGES: "STAKES__LANGUAGES",
  TEMPLES: "TEMPLES",
  WELFARE_LOCATIONS: "WELFARE_LOCATIONS",
  MEETINGHOUSES__UTILIZATIONS: "MEETINGHOUSES__UTILIZATIONS",
  ALL: "ALL",
  NONE: "NONE"
});
export default LocationGroupType;